module.exports = __webpack_public_path__ + "img/icon-payangel-rewards.85a8a5e9.svg";